module.exports = __webpack_public_path__ + "img/bg-welfare.4d6c69be.jpg";